export const trunk = {
  field: {
    my_ip: 'Мой IP адрес',
    zorra_ip: 'Zorra IP адрес',
    type: 'Тип'
  },

  type: {
    outgoing: 'Исходящий',
    caller: 'Caller',
    incoming: 'Входящий'
  },

  modal: {
    remove: {
      content: 'Вы уверены, что хотите удалить транк {name}?'
    }
  },

  button: {
    create: 'Создать транк'
  }
};
